module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "nav-top"
  }, [_c('ul', {
    staticClass: "nav-inline nav-auto nav-inline-fixed"
  }, [_c('li', {
    staticClass: "message-box"
  }, [_c('router-link', {
    staticClass: "text-bold",
    attrs: {
      "to": {
        name: 'feed_follow'
      }
    }
  }, [_vm._v("关注"), _c('span', {
    staticClass: "feed-line"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.number > 0),
      expression: "number > 0"
    }],
    staticClass: "message-number"
  }, [_vm._v(_vm._s(_vm.number))])], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
    staticClass: "text-bold",
    attrs: {
      "to": {
        name: 'feed'
      }
    }
  }, [_vm._v("热门"), _c('span', {
    staticClass: "feed-line"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "text-bold",
    attrs: {
      "to": {
        name: 'feed_home'
      }
    }
  }, [_vm._v("最新"), _c('span', {
    staticClass: "feed-line"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "text-bold",
    attrs: {
      "to": {
        name: 'feed_used'
      }
    }
  }, [_vm._v("二手房车"), _c('span', {
    staticClass: "feed-line"
  })])], 1)])]), _vm._v(" "), _c('scroll', {
    key: "feed-list",
    ref: "scrollComponent",
    staticClass: "app-container app-container-top app-container-bottom",
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, [_c('feed-list-item', {
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadet"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShow),
      expression: "addShow"
    }],
    staticClass: "feed-add-container"
  }, [_c('router-link', {
    staticClass: "feed-add-btn",
    attrs: {
      "to": {
        name: 'feed_add'
      }
    }
  }, [_c('i', {
    staticClass: "fd-publish text-lg"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-md text-bold"
  }, [_vm._v("发圈子")])])], 1)]), _vm._v(" "), _c('tabbar', {
    attrs: {
      "active": "feed"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7206e785"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/feed/home.vue
// module id = 287
// module chunks = 107